export * from "-!../../../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--4-0!../../../../node_modules/vue-style-loader/index.js!../../../../node_modules/css-loader/index.js??ref--4-2!../../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../../node_modules/postcss-loader/lib/index.js??ref--4-3!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Edit.vue?vue&type=style&index=0&id=59ebdc27&prod&scoped=true&lang=css"


//////////////////
// WEBPACK FOOTER
// ./src/pages/Purchases/Freight/Edit.vue?vue&type=style&index=0&id=59ebdc27&prod&scoped=true&lang=css
// module id = 2296
// module chunks = 31